import { contactFormStyles } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

contactFormStyles.submitButton = {
    css: css`
        margin-top: 30px;
        min-width: 200px;
        ${xScreen("lte", "sm")} {
            min-width: 100%;
        }
    `,
};
contactFormStyles.formGridItem = {
    width: 12,
    css: css`
        form {
            width: 100%;
        }
    `,
};
